import { ReactTags } from 'react-tag-autocomplete'
import {twMerge} from "tailwind-merge";

export default function TagInput({label = "", required, value= [], suggestions = [], rowLabel, classes = {}, onAdd, onDelete, ...otherProps}) {

    const {labelClasses = "", tagContainerClasses = ""} = classes;

    function CustomHighlight({ text }) {
        return <span className="bg-pol-main-color">{text}</span>
    }

    return (
        <div className={`relative pol-tag-input ${rowLabel ? "xl:inline-flex items-center" : ""}`}>
            <p className={twMerge(`text-pol-gray-600 text-sm ${rowLabel ? "mb-2 mr-4 xl:ml-4 xl:mb-0 xl:mr-0" : "mb-2.5 mr-2.5"}`, labelClasses)}>
                {label}
                {
                    required ? <span className="align-super text-pol-red text-sm">*</span> : null
                }
            </p>
            <div className={tagContainerClasses}>
                <ReactTags
                    ariaAddedText="افزودن %value%"
                    ariaDeletedText="حذف %value%"
                    deleteButtonText="حذف %value%"
                    newOptionText="افزودن %value%"
                    selected={value}
                    allowNew
                    renderHighlight={CustomHighlight}
                    suggestions={suggestions}
                    onAdd={onAdd}
                    onDelete={onDelete}
                    {...otherProps}
                />
            </div>
        </div>
    )
}
